module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/doctors/pc/icon_noimage-4f88e095035f1194281b459bc8b5439b.png";